import api from './api';

export const languageService = {
  getLanguages: async () => {
    const response = await api.get('/languages');
    return response.data;
  },

  getLanguage: async (id) => {
    const response = await api.get(`/languages/${id}`);
    return response.data;
  },

  createLanguage: async (languageData) => {
    const response = await api.post('/languages', languageData);
    return response.data;
  },

  updateLanguage: async (id, languageData) => {
    const response = await api.put(`/languages/${id}`, languageData);
    return response.data;
  },

  deleteLanguage: async (id) => {
    const response = await api.delete(`/languages/${id}`);
    return response.data;
  }
};
